import { styled, keyframes } from 'styled-components';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: scale(0.95);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
`;

const Wrapper = styled.div`
    --spacing: 0.7em;
    border-radius: 1.5em;
    line-height: 1.8em;
    animation: ${fadeIn} 0.4s ease-out forwards;
`;

export const UserMessage = styled(Wrapper).attrs({
    as: 'p',
})`
    padding: var(--spacing) calc(var(--spacing) * 2);
    align-self: flex-end;
    background: var(--color-accent-blue-30);
    max-width: 25rem;

    scroll-margin-top: 1rem; // Matches with scrollable's top padding
`;

export const AssistantMessage = styled(Wrapper)<{ $isLatest: boolean }>`
    min-height: ${({ $isLatest }) => ($isLatest ? '100vh' : 'auto')};
    padding: var(--spacing) calc(var(--spacing) * 2) var(--spacing) 0; // Assistant message doesn't need padding on left
    text-align: left;
    align-self: flex-start;
    background: white;

    & .markdown ul,
    & .markdown ol {
        padding: 0.25rem 0 0.25rem 3rem;
    }

    & .markdown hr {
        margin: 1rem 0;
        border: 1px solid var(--color-accent-blue-30);
    }
`;

export const Footer = styled.div`
    width: 100%;
    padding-top: 2rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const Datasource = styled.div`
    max-width: 100%;
    padding: 0.25em;
    max-width: var(--max-width);
    padding: 0.5rem 0.75rem;
    border: 1px solid var(--color-primary);
    border-radius: var(--border-radius);

    &:hover {
        cursor: pointer;
        background-color: var(--color-accent-blue-10);
    }
`;

export const DatasourceDivision = styled.div`
    font-weight: 600;
    line-height: 1.3rem;
    color: var(--color-primary);
`;

export const DatasourceChapter = styled.div`
    font-weight: 400;
    font-size: 0.8rem;
    line-height: 1rem;
`;

export const LoadingMessage = styled.div`
    color: var(--color-primary);
`;
